import {createApp} from 'vue'
import App from './App.vue'

import router from './router'
import {store} from './store'
import ElementPlus from "element-plus";
import 'element-plus/dist/index.css'
import elementPLusLocaleTR from 'element-plus/es/locale/lang/tr'
import 'element-plus/theme-chalk/dark/css-vars.css'
import '@/assets/css/dark.css'
import '@/assets/css/midnight.css'
import '@/assets/css/cream.css'
import i18n from "@/core/plugins/vue-i18n";
import { GlobalCmComponent } from "codemirror-editor-vue3";
import Validation from "@/core/helpers/validation";

//imports for app initialization
import ApiService from "@/core/services/ApiService";
import {initApexCharts} from "@/core/plugins/apexcharts";
import {initInlineSvg} from "@/core/plugins/inline-svg";
import {initVeeValidate} from "@/core/plugins/vee-validate";
import {initGlobal} from "@/core/plugins/global";

import "@/core/plugins/keenthemes";
import "@/core/plugins/prismjs";
import platformHandler from '@/core/context/platformHandler'
import tooltip from '@/components/tooltip/tooltip'

const app = createApp(App);

app.use(router);
app.use(ElementPlus, {
    locale: elementPLusLocaleTR,
});
app.use(i18n);
app.use(GlobalCmComponent, { componentName: "Codemirror" });

store._vm = app.config.globalProperties;
app.use(store);

app.config.globalProperties.$handler = platformHandler
store._handler = platformHandler

ApiService.init(app);
Validation.init(app);

initApexCharts(app);
initInlineSvg(app);
initGlobal(app);
initVeeValidate();

app.use(tooltip);

app.mount("#app");
